<div (click)="!disabled ? clicked.emit($event) : null"
     [ngClass]="[colour, padding, opacity, transparent ? 'transparent' : '', solid ? 'solid' : '', disabled ? 'cursor-default' : 'cursor-pointer']"
     [tippy]="tippyContent"
     [attr.data-tippy-touch]="tippyTouch"
     class="status-indicator border-999 vertical-align-content">
    <ion-icon *ngIf="icon" [name]="icon" [ngClass]="fontSize"
              class="no-pointer-events"
              slot="icon-only"></ion-icon>
</div>
